// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB6s4WrujdPHNdJsfy-JvZNfpFUUHEcdpE",
  authDomain: "gpt-3-template.firebaseapp.com",
  projectId: "gpt-3-template",
  storageBucket: "gpt-3-template.appspot.com",
  messagingSenderId: "229608390513",
  appId: "1:229608390513:web:a984afec64e95b9e0000d0",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);
